import React, {Component} from 'react';
import {WasteStreamFilter} from "../../../filters/WasteStreamCode";
import {Button, Form, InputNumber, message} from "antd";
import {WasteStreamPost} from "../../../models/waste_stream";
import {ServiceUpdate} from "../../../models/service";

const FormItem = Form.Item;

class AddNewWasteStream extends Component {
    onSubmit = () => {
        const {service} = this.props;
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (!err) {
                debugger;
                WasteStreamPost(values)
                    .then(response => {
                        const waste_streams = {
                            'waste_stream': [...service.waste_data.map(item => item.id), response.id]
                        };
                        ServiceUpdate(service.id, waste_streams)
                            .then(() => {
                                message.success('Waste Stream added successfully');
                                form.resetFields();
                                this.props.reload();
                            })
                    });
            }
        });
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <div className="row">
                <div className="col-sm-8 col-12">
                    <FormItem>
                        {getFieldDecorator('waste_stream', {
                            rules: [{required: true, message: 'Please select waste stream'}],
                        })(
                            <WasteStreamFilter/>
                        )}
                    </FormItem>
                </div>
                <div className=" col-sm-4 col-12">
                    <FormItem>
                        {getFieldDecorator('quantity', {
                            rules: [{required: true, message: 'Please enter quantity'}],
                        })(
                            <InputNumber placeholder="Enter Quantity"/>
                        )}
                    </FormItem>
                </div>
                <div className="col-12">
                    <Button style={{marginTop: 10}} onClick={this.onSubmit} type="primary">Add New</Button>
                </div>
            </div>
        );
    }
}

export default Form.create()(AddNewWasteStream);


// WEBPACK FOOTER //
// ./src/pages/dispatch/routes/AddNewWasteStream.jsx